/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Progress_LabelInputs */

const en_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import progress`)
};

const fr_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression de l'importation`)
};

const de_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importfortschritt`)
};

const it_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzamento dell'importazione`)
};

const ru_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ход импорта`)
};

const es_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso de la importación`)
};

const zh_cn2_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入进度`)
};

const ja_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートの進行状況`)
};

const hi_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात प्रगति`)
};

const pt_pt2_iconik_import_progress_label = /** @type {(inputs: Iconik_Import_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso da importação`)
};

/**
* | output |
* | --- |
* | "Import progress" |
*
* @param {Iconik_Import_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_progress_label = /** @type {((inputs?: Iconik_Import_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_progress_label(inputs)
	if (locale === "de") return de_iconik_import_progress_label(inputs)
	if (locale === "it") return it_iconik_import_progress_label(inputs)
	if (locale === "ru") return ru_iconik_import_progress_label(inputs)
	if (locale === "es") return es_iconik_import_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_progress_label(inputs)
	if (locale === "ja") return ja_iconik_import_progress_label(inputs)
	if (locale === "hi") return hi_iconik_import_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_progress_label(inputs)
	return en_iconik_import_progress_label(inputs)
});